import React, {Component} from 'react';
import {Form, Row, Col, Select, Input, Button, message, InputNumber} from 'antd'
import {listFormItemLayout, tailFormItemLayout} from '../../utills/common'
import {reqCreateBarcode, reqUpdateBarcode, reqBarcodeInfo} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)

const {Option} = Select;
let id;
class BarcodeAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            origin: [],
            destination: [],
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.saveAddress(values);
            }
        });
    };

    saveAddress = async (values) => {
        let result;
        if (id) {
            values.id = id;
            result = await reqUpdateBarcode(values);
            if (result.code === 200) {
                this.props.history.replace('/barcodeList')
            } else {
                message.error(result.message);
            }
        } else {
            result = await reqCreateBarcode(values);
            if (result.code === 201) {
                this.props.history.replace('/barcodeList')
            } else {
                message.error(result.message);
            }
        }

    };
    getAddress = async (id) => {
        let result = await reqBarcodeInfo(id);
        if (result.code === 200) {
            this.setState(result.data);
        }
    };

    componentDidMount() {
        id = this.props.location.state ? this.props.location.state.id : '';
        if (id) {
            this.getAddress(id);
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div className='order-ticket box-shadow'>
                <div className="head-title">
                    条形码管理
                </div>
                <div className="order-ticket-content">
                    <Form {...listFormItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="收货人">
                                    {getFieldDecorator('receiver', {
                                        initialValue: this.state.receiver,
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="收货人电话">
                                    {getFieldDecorator('phone', {
                                        initialValue: this.state.phone,
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="收货人地址">
                                    {getFieldDecorator('address', {
                                        initialValue: this.state.address,
                                        rules: [{required: true, message: '该项必填'},],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="数量">
                                    {getFieldDecorator('nums', {
                                        initialValue: this.state.nums,
                                        rules: [{required: true, message: '该项必填,且最大值为300'}, {
                                            pattern: /^[1-9]\d*$/, message: '必须为大于0的整数'
                                        }],
                                    })(<InputNumber disabled={this.state.id}/>)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <div className='box-submit'>
                            <Form.Item {...tailFormItemLayout}>
                                <AuthButton type="primary" htmlType="submit">保存</AuthButton>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>)
    }
}
const BarcodeAddForm = (Form.create()(BarcodeAdd));
export default BarcodeAddForm;